// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
// import Typography from "@insite/mobius/Typography"; // Starter Custom Code
import * as React from "react";
import { connect } from "react-redux";

/* Starter Custom Code - Start */
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";

export interface PageTitleStyles {
    title?: TypographyPresentationProps;
}

export const pageTitleStyles: PageTitleStyles = {
    title: {
        variant: "h1",
    },
};

const styles = pageTitleStyles;
/* Starter Custom Code - End */

const mapStateToProps = (state: ApplicationState) => ({
    pageTitle: getCurrentPage(state).fields.title,
});

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

const PageTitle: React.FunctionComponent<Props> = ({ pageTitle, fields }: Props) => (
    <Typography {...styles.title /* Starter Custom Code */} data-test-selector="PageTitle">
        {fields.overrideTitle || pageTitle}
    </Typography>
);

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(PageTitle),
    definition: {
        group: "Basic",
        icon: "heading",
    },
};

export default widgetModule;
